export interface TipoInmueble {
    label: string;
    value: number;
  }
  
  export interface DestinoInmueble {
    label: string;
    value: number;
  }
  
  export interface ArrendamientoInmueble {
    label: string;
    value: number;
  }
  export const TIPOS_INMUEBLE: TipoInmueble[] = [
    {"label": "CASA", "value": 1},
    {"label": "LOCAL", "value": 2},
    {"label": "BODEGA", "value": 3},
    {"label": "APARTAMENTO", "value": 4},
    {"label": "OFICINA", "value": 5},
    {"label": "OTRO", "value": 6}
  ];
  
  export const DESTINOS_INMUEBLE: DestinoInmueble[] = [
    {"label": "RESIDENCIAL", "value": 1},
    {"label": "COMERCIAL", "value": 2}
  ];
  
  export const ARRENDAMIENTOS_INMUEBLE: ArrendamientoInmueble[] = [
    {"label": "TOTAL", "value": 1},
    {"label": "PARCIAL", "value": 2}
  ];